import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cancel",
  "use": "cancel-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"cancel\">\r\n    <path d=\"M9.99974 8.82208L14.1246 4.69727L15.3031 5.87577L11.1782 10.0006L15.3031 14.1253L14.1246 15.3038L9.99974 11.1791L5.87496 15.3038L4.69644 14.1253L8.82124 10.0006L4.69644 5.87577L5.87496 4.69727L9.99974 8.82208Z\" fill=\"currentColor\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol